import { render } from "./top.vue?vue&type=template&id=1be976aa&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"

import "@/assets/css/global.css?vue&type=style&index=0&lang=css"
import "./top.vue?vue&type=style&index=1&id=1be976aa&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be976aa"]])

export default __exports__